import { DefaultThemeId } from "./theme/theme";

const createStyles = () => {
  return `
      <style>
        body {
          font-size: 16px;
          padding: 1em;
          font-family: sans-serif;
        }

        .egwwritings {
          color: var(--category-egw);
          fill: var(--category-egw);
        }

        .egwwritings.mark {
          background: var(--category-egw);
          color: white;
        }

        .search-item-wrap {
          font-family: "Roboto Condensed", sans-serif;
          cursor: pointer;
          overflow: hidden;
          text-overflow: ellipsis;
          border-bottom: 1px solid var(--icon-color);
          padding: 14px;
          box-sizing: border-box;
        }

        .search-item-title {
          font-family: "Roboto Condensed", sans-serif;
          font-style: normal;
          font-weight: bold;
          white-space: nowrap;
          height: 25px;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 16px;
          text-transform: uppercase;
          line-height: 32px;
        }

        .search-item-snippet {
          font-family: "Roboto Condensed", sans-serif;
          color: var(--text-default);
          overflow: hidden;
          text-overflow: ellipsis;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 1.25;
          max-height: calc(100% - 35px);
        }

        .search-item-wrap.egwwritings .search-item-snippet,
        .search-item-wrap.reference .search-item-snippet,
        .search-item-wrap.bible .search-item-snippet,
        .search-item-wrap.apl .search-item-snippet {
          color: var(--text-default);
        }
      </style>
    `;
};

export const makeSearchPrintTitle = (t, query, from, to) => {
  return `${t("searchResults")} "${query}" (${from} - ${to})`;
};

export const makeReaderPrintTitle = (chapter) => {
  if (chapter) {
    return chapter.refcode_short + " — " + chapter.title;
  }
  return undefined;
};

export const createPrintWindow = (html, title = "Print") => {
  const win = window.open(undefined, "_blank");
  if (win && win.document) {
    win.document.write("<title>" + title + "</title>");
    win.document.write(
      `<link rel="stylesheet" href="${window.location.origin}/styles/${DefaultThemeId}.css"/>`
    );
    win.document.write(createStyles());
    win.document.write(html);
    win.focus();
    win.print();
  } else {
    alert("Your browser prevented the window from opening Please allow to open a new window.");
  }
};

export const createPrintWindowFile = (url) => {
  const win = window.open(url, "_blank");
  if (win && win.document) {
    win.focus();
    // win.print();
  } else {
    alert("Your browser prevented the window from opening Please allow to open a new window.");
  }
};
